import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ListArchivedWorkAreas from 'modules/locations/components/ListArchivedWorkAreas'
import { useWorkAreas } from 'modules/locations/hooks/useWorkAreas'

const ArchivedWorkAreasPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { locationId } = useOutletContext<{ locationId: number }>()

  const { workAreas, loading, error } = useWorkAreas({
    locationIds: [locationId],
  })
  const archivedWorkAreas = workAreas.filter((workArea) => !!workArea.archivedAt)

  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const spacesEnabled = moduleAvailability.available

  if (!hasFeature('dev_location_work_areas') && !spacesEnabled) {
    navigate(navigation.settings.locations.fullPath())

    return null
  }

  return (
    <ResponsivePage.Body variant="narrow" loading={loading} error={error}>
      <ListArchivedWorkAreas items={archivedWorkAreas} />
    </ResponsivePage.Body>
  )
}

export default ArchivedWorkAreasPage
